import type { TextComponentProps } from '@eturi/react-i18next'

type TextTags = 'i' | 'strong' | 'text'
type TextExtraProps = {
	readonly bold?: boolean
	readonly color?: string
	readonly italic?: boolean
}

export const TextTrans = ({
	bold,
	children,
	color,
	italic,
	type,
}: TextComponentProps<TextTags, TextExtraProps>) => {
	const fontStyle = italic || type == 'i' ? 'italic' : undefined
	const fontWeight = bold || type == 'strong' ? 'bold' : undefined

	// No reason to create a new node for plain text or an empty wrapper.
	if (!(color || fontStyle || fontWeight)) return children

	return (
		<span className="text-node" style={{ color, fontWeight, fontStyle }}>
			{children}
		</span>
	)
}
